var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatherPauseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.5,
    height: 41.5,
    viewBox: "0 0 41.5 41.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-pause-circle",
    "data-name": "Icon feather-pause-circle",
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16815",
    "data-name": "Group 16815",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11367",
    "data-name": "Path 11367",
    d: "M43,23A20,20,0,1,1,23,3,20,20,0,0,1,43,23Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#ff1c00",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11368",
    "data-name": "Path 11368",
    d: "M.9,38.253V.022",
    transform: "translate(33.203 5.782) rotate(47)",
    fill: "none",
    stroke: "#ff1c00",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "iconfinder_icon-social-twitter_211920",
    "data-name": "iconfinder icon-social-twitter 211920",
    d: "M-257.121,67.869a14.161,14.161,0,0,1-4.032,1.109,7.04,7.04,0,0,0,3.089-3.886,13.926,13.926,0,0,1-4.459,1.7,7.018,7.018,0,0,0-9.919-.334,7.016,7.016,0,0,0-2.226,5.134,6.889,6.889,0,0,0,.181,1.6,19.89,19.89,0,0,1-14.473-7.345,7.04,7.04,0,0,0,2.175,9.383,6.842,6.842,0,0,1-3.183-.877v.087a7.026,7.026,0,0,0,5.63,6.893,7.035,7.035,0,0,1-1.849.247,6.58,6.58,0,0,1-1.32-.131,7.03,7.03,0,0,0,6.569,4.88,14.072,14.072,0,0,1-8.723,3.009,14,14,0,0,1-1.675-.1,19.657,19.657,0,0,0,10.753,3.176c12.921,0,19.984-10.71,19.984-20,0-.3-.007-.609-.022-.906A14.381,14.381,0,0,0-257.121,67.869Z",
    transform: "translate(298.336 -53.443)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeLinejoin: "bevel",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherPauseCircle);
export default __webpack_public_path__ + "static/media/feather-pause-circle.9e14b91a77199be9a893834ee50c0fdf.svg";
export { ForwardRef as ReactComponent };